import { useSelector } from "react-redux";
import { CreateUser } from "../../../store/user-store/user-actions"; 
import UserForms from "../../../components/Forms/UserForms";
import { GetUsers } from "../../../store/user-store/user-actions";
import { getTokenInfo } from "../../../utils/Guard";

const UsersCreate = () => {
  const user = useSelector((state) => state.user.user);
  
  return (
    <>
    <div style={{ backgroundColor: "#133047", padding: "1%", height: "62.5rem" }}>
      <UserForms actionUser={CreateUser} user={user} />
    </div>
    </>
  );
};
export default UsersCreate;
